import { jsx as _jsx } from "react/jsx-runtime";
import ClinicRooms from 'pages/ClinicRooms';
import ShowClinicRoom from 'pages/ShowClinicRoom';
import { Route } from 'react-router';
import AuthorizationService from 'routes/AuthorizationService';
import { Index, Show } from 'constants/actions';
import { ClinicRoom as ClinicRoomResource } from 'constants/resources';
var ClinicRoomRoutes = function () {
    return ([
        _jsx(Route, { caseSensitive: true, path: '/clinic_rooms/:id', element: AuthorizationService.getAuthorizedElement(_jsx(ShowClinicRoom, {}), Show, ClinicRoomResource) }, 'show-clinic-room-route'),
        _jsx(Route, { caseSensitive: true, path: '/clinic_rooms', element: AuthorizationService.getAuthorizedElement(_jsx(ClinicRooms, {}), Index, ClinicRoomResource) }, 'clinic-rooms-route')
    ]);
};
export default ClinicRoomRoutes;
